import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { Trans } from "react-i18next";
import { RiArticleLine } from "react-icons/ri";
import {
  FaChartLine,
  FaRegNewspaper,
} from "react-icons/fa";
import { GlobalContext } from "../Context/GlobalState";
import { RiEdgeNewFill, RiMailSettingsFill, RiPagesLine } from "react-icons/ri";
import { GrBlockQuote, GrDocumentTxt } from "react-icons/gr";

const style = {
  color: "#FFF",
};
const activeStyle = {
  color: "#FFF",
  fontWeight: "bold",
};

const Sidebar = () => {
  const [seoOverallMenuOpen, setSeoOverallMenuOpen] = useState(true);
  const [seoMenuOpen, setSeoMenuOpen] = useState(false);
  const [blogsMenuOpen, setBlogsMenuOpen] = useState(false);
  const [workspaceMenuOpen, setWorkspaceMenuOpen] = useState(false);
  const [asoMenuOpen, setAsoMenuOpen] = useState(false);
  const [asoSettingsMenuOpen, setAsoSettingsMenuOpen] = useState(false);
  const [guestPostingMenuOpen, setGuestPostingMenuOpen] = useState(false);
  const [onboardMenuOpen, setonboardMenuOpen] = useState(false);
  const [blogmenu, setblogmenu] = useState(true);
  const [Setting, setSetting] = useState(false);
  const { user, isVerified } = useContext(GlobalContext);
  console.log(user);
  const location = useLocation();
  const isPathActive = (path) => {
    return location.pathname.startsWith(path);
  };
  const handleMenuClick = (menuState) => {
    if (
      menuState !== "seoMenuOpen" &&
      menuState !== "blogsMenuOpen" &&
      menuState !== "workspaceMenuOpen" &&
      menuState !== "asoMenuOpen" &&
      menuState !== "asoSettingsMenuOpen" &&
      menuState !== "guestPostingMenuOpen" &&
      menuState !== "onboardMenuOpen" &&
      menuState !== "Setting" &&
      menuState !== "blog"
    ) {
      return;
    }
    toggleMenuState(menuState);
  };

  const toggleMenuState = (menuState) => {
    if (menuState === "seoMenuOpen") setSeoMenuOpen(!seoMenuOpen);
    if (menuState === "blogsMenuOpen") setBlogsMenuOpen(!blogsMenuOpen);
    if (menuState === "workspaceMenuOpen")
      setWorkspaceMenuOpen(!workspaceMenuOpen);
    if (menuState === "asoMenuOpen") setAsoMenuOpen(!asoMenuOpen);
    if (menuState === "asoSettingsMenuOpen")
      setAsoSettingsMenuOpen(!asoSettingsMenuOpen);
    if (menuState === "guestPostingMenuOpen")
      setGuestPostingMenuOpen(!guestPostingMenuOpen);
    if (menuState === "onboardMenuOpen") setonboardMenuOpen(!onboardMenuOpen);
    if (menuState === "Setting") setSetting(!Setting);
    if (menuState === "blog") setblogmenu(!blogmenu);
  };
  useEffect(() => {
    // fetchUserInfo();
    onRouteChanged();

    const body = document.querySelector("body");
    document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
      el.addEventListener("mouseover", () => {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", () => {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });

    return () => {
      document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
        el.removeEventListener("mouseover", () => {});
        el.removeEventListener("mouseout", () => {});
      });
    };
  }, []);

  const onRouteChanged = () => {
    document.querySelector("#sidebar").classList.remove("active");
    const dropdownPaths = [
      { path: "/Go_seo", state: "seoMenuOpen" },
      { path: "/Go_blog", state: "blogsMenuOpen" },
    ];

    dropdownPaths.forEach((obj) => {
      if (isPathActive(obj.path)) {
        toggleMenuState(obj.state);
      }
    });
  };
  const canViewMenu = (menuType) => {
    const userType = user?.user_type;
    if (menuType === "A") {
      return userType === "A";
    }
    if (menuType === "U") {
      return userType === "U";
    }
    if (menuType === "S") {
      return userType === "S";
    }
    return false;
  };

  return (
    <nav
      style={{ background: "#31393C", minHeight: "100vh" }}
      className="sidebar sidebar-offcanvas"
      id="sidebar"
    >
      <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
        <a className="sidebar-brand brand-logo" href="index.html">
          <strong style={{ color: "#FFF" }}>SeoBix</strong>
        </a>
        <a className="sidebar-brand brand-logo-mini" href="index.html">
          SB
        </a>
      </div>

      <ul
        className="nav"
        style={{
          overflowY: "scroll",
          height: "100vh",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {/* {canViewMenu("S") && ( */}
          <>
            <li
              className={
                blogmenu ? "nav-item menu-items active" : "nav-item menu-items"
              }
              style={{
                ...(blogmenu ? activeStyle : style),
                marginTop: "5px",
                // ...(!isVerified && { pointerEvents: "none", opacity: "0.5" }),
              }}
            >
              <div
                className={blogmenu ? "nav-link menu-expanded" : "nav-link"}
                onClick={() => handleMenuClick("blog")}
                // onClick={
                //   !isVerified
                //     ? undefined
                //     : () => handleMenuClick("guestPostingMenuOpen")
                // }
                data-toggle="collapse"
              >
                <span className="p-2">
                  <FaRegNewspaper
                    style={{
                      color: "#FF9100",
                      fontSize: "1.2rem",
                      marginRight: ".3rem",
                    }}
                  />
                </span>
                <span style={{ color: "#FFF" }} className="menu-title">
                  Blog
                </span>

                <i className="menu-arrow" style={{ color: "pink" }}></i>
              </div>
              <Collapse in={blogmenu}>
                <ul className="nav flex-column sub-menu px-3">
                  <li
                    style={{
                      ...(isPathActive("/blog/Addblog") ? activeStyle : style),
                      marginTop: "5px",
                    }}
                    className={
                      isPathActive("/blog/Addblog")
                        ? "nav-item menu-items active"
                        : "nav-item menu-items"
                    }
                  >
                    <Link className="nav-link" to="/blog/Addblog">
                      <span className="p-2">
                        <FaChartLine
                          style={{ color: "#41B06E", fontSize: "1rem" }}
                        />
                      </span>
                      <span style={{ color: "#FFF" }} className="menu-title">
                        Add New Blog
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      ...(isPathActive("/blog/Allblog") ? activeStyle : style),
                    }}
                    className={
                      isPathActive("/blog/Allblog")
                        ? "nav-item menu-items active"
                        : "nav-item menu-items"
                    }
                  >
                    <Link className="nav-link" to="/blog/Allblog">
                      <span className="p-2">
                        <RiMailSettingsFill
                          style={{
                            color: "#C68EFD",
                            marginRight: ".3rem",
                            fontSize: "1rem",
                          }}
                        />
                      </span>
                      <span style={{ color: "#FFF" }} className="menu-title">
                        All Blogs
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      ...(isPathActive("/blog/Blog-author")
                        ? activeStyle
                        : style),
                      marginTop: "5px",
                    }}
                    className={
                      isPathActive("/blog/Blog-author")
                        ? "nav-item menu-items active"
                        : "nav-item menu-items"
                    }
                  >
                    <Link className="nav-link" to="/blog/Blog-author">
                      <span className="p-2">
                        <GrBlockQuote
                          style={{ color: "#E9A5F1", fontSize: "1rem" }}
                        />
                      </span>
                      <span style={{ color: "#FFF" }} className="menu-title">
                        Author
                      </span>
                    </Link>
                  </li> 
                  {/* <li
                    style={{
                      ...(isPathActive("/blog/test")
                        ? activeStyle
                        : style),
                      marginTop: "5px",
                    }}
                    className={
                      isPathActive("/blog/test")
                        ? "nav-item menu-items active"
                        : "nav-item menu-items"
                    }
                  >
                    <Link className="nav-link" to="/blog/test">
                      <span className="p-2">
                        <GrBlockQuote
                          style={{ color: "#E9A5F1", fontSize: "1rem" }}
                        />
                      </span>
                      <span style={{ color: "#FFF" }} className="menu-title">
                        Test
                      </span>
                    </Link>
                  </li> */}
                </ul>
              </Collapse>
            </li>
          </>
        {/* )} */}
     
      </ul>
    </nav>
  );
};

export default Sidebar;
